import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert } from 'src/domains/common/components/alert/alert';
import Loading from 'src/components/Loading/Loading';
import { useAppStateContext } from 'src/AppState/AppState';
import { DefaultDepositLimitsState } from 'src/components/ComplianceConfiguration/DefaultDepositLimits/DefaultDepositLimits.state';
import { DefaultDepositLimitsForm } from 'src/components/ComplianceConfiguration/DefaultDepositLimits/DefaultDepositLimitsForm';
import { DefaultDepositLimitsWrapper } from 'src/components/ComplianceConfiguration/DefaultDepositLimits/DefaultDepositLimits.style';

export const DefaultDepositLimits = observer((): JSX.Element => {
    const appState = useAppStateContext();
    const [state] = useState(() => new DefaultDepositLimitsState(appState));

    if (state.isLoading) {
        return (
            <DefaultDepositLimitsWrapper data-test='default-deposit-limits-loading'>
                <Loading active />
            </DefaultDepositLimitsWrapper>
        );
    }

    return (
        <DefaultDepositLimitsWrapper data-test='default-deposit-limits'>
            <Alert
                icon='info'
                title='Signup deposit limits'
                variant='default'
            >
                During signup - only 1, 7 and 30 days (rolling) or Daily, Weekly and Monthly (calendar) are visible and
                editable by the player.
            </Alert>

            <div data-test='default-deposit-limits-net-type-info'>
                <Alert
                    icon='info'
                    title='Active Limit Value and Max Limit Value'
                    variant='default'
                >
                    Entering an amount sets both the Active Limit Value and the Max Limit Value. These values are linked
                    and cannot be applied separately
                </Alert>
            </div>

            {state.errorMessage === null || state.errorMessage === '' ? null : (
                <Alert
                    icon='info'
                    title={state.errorMessage}
                    variant='destructive'
                />
            )}

            {state.addErrorMessage === null || state.addErrorMessage === '' ? null : (
                <Alert
                    icon='info'
                    title={state.addErrorMessage}
                    variant='destructive'
                />
            )}

            <DefaultDepositLimitsForm state={state} />
        </DefaultDepositLimitsWrapper>
    );
});
